import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { ArticleGetError, ArticleParams } from '../model/articleModel';
import Breadcrumbs from '../../../components/Breadcrumbs';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import { PANEL_VIEW } from '../../../components/SearchPanel/enum/searchPanelProps';
import PageView from '../../../components/PageView';
import * as BreadcrumbsModel from '../../../shared/model/commonModel';
import { ROUTES } from '../../../core/router/routes';
import { useLazyGetCategoryTreesQuery } from '../../category/api/categoryApi';
import { useGetArticleQuery } from '../api/articleApi';
import { API_STATUS_CODE } from '../../../core/enums/apiStatusCode';
import { setBreadcrumbs } from '../../../shared/redux/commonSlice';

import './articleShow.scss';
import Survey from '../../../components/Survey';
const ArticleShow: React.FC = () => {
  const params = useParams<ArticleParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const { show, hide } = useMainProgressContext();

  const [
    getCategoryTree,
    { data: categoryTrees, isSuccess: isSuccessCategoryTrees, isLoading: isLoadingCategoryTrees },
  ] = useLazyGetCategoryTreesQuery();
  const {
    data: article,
    isSuccess: isSuccessArticle,
    isLoading: isLoadingArticle,
    isError: isErrorArticle,
    error: errorArticle,
  } = useGetArticleQuery({
    id: params.id,
  });

  useEffect(() => {
    if (isSuccessCategoryTrees && categoryTrees && article && isSuccessArticle) {
      let breadcrumbs: BreadcrumbsModel.Breadcrumbs[] = [];

      categoryTrees.forEach((category) => {
        if (category.parent) {
          breadcrumbs.push({
            label: category.name,
            to:
              article.category.id !== category.id
                ? ROUTES.CATEGORY.ARTICLE.replace(':id', category.id as unknown as string)
                : null,
          });
        }
      });

      dispatch(setBreadcrumbs(breadcrumbs));

      hide();
    }
  }, [categoryTrees, isSuccessCategoryTrees, article, isSuccessArticle]);

  useEffect(() => {
    if (isLoadingCategoryTrees && isLoadingArticle) {
      show();
    }
  }, [isLoadingCategoryTrees, isLoadingArticle]);

  useEffect(() => {
    if (isSuccessArticle && article.id) {
      getCategoryTree({
        id: article.category.id as unknown as string,
      });
    }
  }, [article, isSuccessArticle]);

  useEffect(() => {
    if (isErrorArticle) {
      const error = errorArticle as ArticleGetError;

      switch (error.status) {
        case API_STATUS_CODE.NOT_FOUND:
          history.push(ROUTES.ERROR_404);
          break;
      }
    }
  }, [isErrorArticle]);

  return (
    <PageView
      view={PANEL_VIEW.MINIMUM}
      showMoreArticlesInCategory={true}
      showShortContact={true}
      className="ArticleShow-PageView"
      categoryId={article?.category.id as unknown as string}
    >
      <Breadcrumbs title={article?.title} />
      <section className="article">
        <div className="title">
          <h1>{article?.title}</h1>
        </div>
        <div className="content" dangerouslySetInnerHTML={{ __html: article?.content || '' }}></div>
      </section>
      <Survey />
    </PageView>
  );
};

export default ArticleShow;
